import {
  UIButton,
  UIButtonSize,
  UIButtonVariant,
} from '@perpetua1/oasis-react';
import { Link } from 'gatsby';
import React, { FC } from 'react';
import { customDataLayerPush } from 'src/utils/analytics';
import { DL_EVENT, PAGE_SLOT } from 'src/utils/analytics/constants';

export interface ColumnCtaProps {
  title: string;
  description?: string;
  buttonText?: string;
  buttonLink?: string;
}

const ColumnCta: FC<ColumnCtaProps> = props => {
  const { title, description, buttonText, buttonLink } = props;
  return (
    <p className="font-semibold text-indigo-3-dark text-lg">
      {title}
      {description && (
        <span className="block font-medium text-gray-3-dark my-3">
          {JSON.parse(description).content[0].content[0].value}
        </span>
      )}
      <UIButton
        variant={UIButtonVariant.secondary}
        size={UIButtonSize.large}
        text={<Link to={buttonLink}>{buttonText}</Link>}
        onClick={() => customDataLayerPush(DL_EVENT.elementClick, {pageSlot: PAGE_SLOT.Navi, label: buttonText})}
      />
    </p>
  );
};

export default ColumnCta;
